module.exports = __webpack_public_path__ + "img/02.0a351347.jpg";